import { render, staticRenderFns } from "./VerticalMenu.vue?vue&type=template&id=de020166&scoped=true"
import script from "./VerticalMenu.vue?vue&type=script&lang=js"
export * from "./VerticalMenu.vue?vue&type=script&lang=js"
import style0 from "./VerticalMenu.vue?vue&type=style&index=0&id=de020166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de020166",
  null
  
)

export default component.exports